import React, { useState, useEffect } from "react";
import RegionalStatements from "./RegionalStatements";
import JoinTheDiscussion from "./JoinTheDiscussion";
import { Grid } from "@material-ui/core";
import { useAuth } from "../../firebase/AuthProvider";
import NewestStatement from "./NewestStatement";
import PopularStatements from "./PopularStatements";
import FavoriteStatements from "./FavoriteStatements";
import CommentedOnStatements from "./CommentedOnStatements";
import UserContribution from "./UserContribution";
import SuccessDialog from "../signup/SuccessDialog";

export default function Dashboard() {
  const { isSignedIn } = useAuth();
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  useEffect(() => {
    const status = sessionStorage.getItem("justSignedUp");
    // Firefox can only read "strings"
    if (status && JSON.parse(status)) {
      sessionStorage.removeItem("justSignedUp");
      setOpenSuccessDialog(true);
    }
  }, []);

  const handleClose = () => {
    setOpenSuccessDialog(false);
  };

  return (
    <>
      <Grid container item>
        <SuccessDialog open={openSuccessDialog} onClose={handleClose} />

        <Grid container item>
          <NewestStatement />
        </Grid>

        <Grid container item style={{ margin: "10px" }}>
          <Grid container item>
            <PopularStatements />
          </Grid>

          {isSignedIn && (
            <>
              <Grid container item>
                <FavoriteStatements />
              </Grid>

              <Grid container item>
                <CommentedOnStatements />
              </Grid>

              <Grid container item>
                <RegionalStatements />
              </Grid>
            </>
          )}
          <Grid container item>
            <UserContribution />
          </Grid>
        </Grid>

        {!isSignedIn && (
          <Grid container item>
            <JoinTheDiscussion />
          </Grid>
        )}
      </Grid>
    </>
  );
}
